var jquery = require("jquery");
window.$ = window.jQuery = jquery;
var visible = require("jquery-visible");

var blast = require("blast-text");

var selectric = require("selectric");

require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;

import Swiper from 'swiper/bundle';
import Rellax from 'rellax';
// import ScrollOut from "scroll-out";

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();


var rellax = new Rellax('.rellax', {});
var rellaxH = new Rellax('.rellax-horizontal', {
	horizontal:true
});


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

$('.selectric').selectric({
	expandToItemText: true,
	arrowButtonMarkup: '<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="8.914" height="5.871" viewBox="0 0 8.914 5.871"><path id="Path_29817" data-name="Path 29817" d="M550.816,875.664l-4.457-4.457,1.414-1.414,3.043,3.043,3.043-3.043,1.414,1.414Z" transform="translate(-546.359 -869.793)" fill="currentColor"/></svg></b>',
	onInit: function(e) {
		$('input.selectric-input').attr('readonly', true); 
	},
	onOpen: function(e) {
		var ulH = $(this).parent().parent().find('.selectric-items .selectric-scroll ul').height();
		if ($(window).width() >= 1280) {
			var maxH = 240;
		} else {
			var maxH = 160;
		}
		if (ulH > maxH) {
			ulH = maxH;
			setTimeout(() => {
				$(this).parent().parent().find('.selectric-items .selectric-scroll').addClass('auto');
			}, 600);
		}
		$(this).parent().parent().find('.selectric-items .selectric-scroll').height(ulH);
	},
	onBeforeClose: function() {
		$(this).parent().parent().find('.selectric-items .selectric-scroll').removeClass('auto');
		$(this).parent().parent().find('.selectric-items .selectric-scroll').removeAttr('style');
	},
});



// READY

$(function () {

	var scroll = $(window).scrollTop();

	console.log('Website proudly by Imagic Creative');
	$('body').addClass('loaded');
	$('body').removeAttr('style');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);


	
	if ($('.home-hero-slides').length && $(window).width() >= 1280) {
		
		homeHeroHeadInit(scroll);
		
	}


	if ($('.fuel-row').length) {
		$('.fuel-row .fuel-trigger:visible').first().trigger('click');
	}

	if ($(window).width() >= 1280 && $('body.homepage').length) {
		$(".floating-heading-one h1").blast({ delimiter: "character", generateValueClass: true });
		$(".floating-heading-two .h1").blast({ delimiter: "character" });
	}

	calcDrawerInit();


	if ($('.filters .store-filter').length) {
		var type = getUrlParameter('type');
		if (type) {
			$('.filters .store-filter[data-type="' + type + '"]').trigger('click');
		}
	}

	// weird fix for jumpy parallax
	if ($('.section-page-callouts').length) {
		$('.section-page-callouts').css('z-index', '80');
	}

});

// SCROLL

$(window).on('scroll', function(e) {
	// console.log('scroll');
	var scroll = $(window).scrollTop();

	didScroll = true;
	
	var section = $('.home-hero-slides');
	if (section.length && $(window).width() >= 1280) {
		var sectionOffset = section.offset().top;
		var inner = section.find('.home-hero-slides-inner');
		if (scroll >= sectionOffset || inner.visible(true)) {
			if (inner.visible(true)) {
				homeHeroHead(scroll);
			}
			homeHeroSlides(scroll, section);
		}
	}

});



// RESIZE

$(window).on('resize', function() {

	// console.log('resize');

	var scroll = $(window).scrollTop();
	
	if ($(window).width() >= 1280) {
		$('.section-calc-mobile .toggle-calc').removeClass('open');
		$('.headerContainer').add('body').removeClass('mobile-calc-open');
		$('.hamburger').removeClass('open');
		$('.headerContainer').add('body').removeClass('mobile-menu-open');
	} else {
		$('.home-hero-slides *').removeAttr('style');
		// calcDrawer('close');
	}

	if ($('.home-hero-slides').length && $(window).width() >= 1280) {
		setTimeout(() => {
			homeHeroHeadInit(scroll);
		}, 400);
	}

	calcDrawerInit();

});




// SLIDERS

if ($('.fires-slider').length) {
	$('.fires-slider').each(function() {
		var thisSlider = $(this);
		var totalSlides = thisSlider.find('.swiper-slide').length;
		const slider = new Swiper(thisSlider[0], {
			slidesPerView: 1,
			spaceBetween: 0,
			autoResize: false,
			centeredSlides: false,
			centerInsufficientSlides: true,
			speed: 300,
			navigation: {
				nextEl: thisSlider.find('.swiper-button-next')[0],
				prevEl: thisSlider.find('.swiper-button-prev')[0],
			},
			scrollbar: false,
			pagination: {
				el: thisSlider.find('.swiper-pagination')[0],
				type: 'fraction',
				formatFractionCurrent: function(n) {
					return n;
				},
				formatFractionTotal: function(n) {
					return totalSlides;
				}
			},
			loop: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {
				640: {
					slidesPerView: 2,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 2) {
								return n + 1;
							} else {
								return totalSlides;
							}
						},
					},
				},
				768: {
					slidesPerView: 3,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 3) {
								return n + 2;
							} else {
								return totalSlides;
							}
						},
					},
				},
				1024: {
					slidesPerView: 4,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 4) {
								return n + 3;
							} else {
								return totalSlides;
							}
						},
					},
				},
				1280: {
					slidesPerView: 5,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 5) {
								return n + 4;
							} else {
								return totalSlides;
							}
						},
					},
				},
				1696: {
					slidesPerView: 6,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 6) {
								return n + 5;
							} else {
								return totalSlides;
							}
						},
					},
				},
				1920: {
					slidesPerView: 7,
					pagination: {
						formatFractionCurrent: function(n) {
							if (totalSlides > 7) {
								return n + 6;
							} else {
								return totalSlides;
							}
						},
					},
				},
			}
		});
	});

	$('.fuel-trigger').on("click", function(e) {
		// console.log('fuel-trigger');
		$('.fuel-trigger').removeClass('active');
		$(this).addClass('active');
		var fuel = $(this).data('fuel');
		$('.fires-slider').hide();
		$('.fires-slider[data-fuel="' + fuel + '"]').show();
	});
}

if ($('.related-fires-slider').length) {
	$('.related-fires-slider').each(function() {
		var thisSlider = $(this);
		const slider = new Swiper(thisSlider[0], {
			slidesPerView: 2,
			spaceBetween: 0,
			autoResize: false,
			centeredSlides: false,
			centerInsufficientSlides: true,
			speed: 300,
			navigation: {
				nextEl: thisSlider.find('.swiper-button-next')[0],
				prevEl: thisSlider.find('.swiper-button-prev')[0],
			},
			scrollbar: false,
			pagination: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {
				640: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 3,
				},
			}
		});
	});

}


if ($('.product-detail-slider').length) {
	$('.product-detail-slider').each(function() {
		var thisSlider = $(this);
		const slider = new Swiper(thisSlider[0], {
			slidesPerView: 1,
			spaceBetween: 0,
			autoHeight: true,
			allowTouchMove: false,
			speed: 1200,
			// effect: "creative",
			// creativeEffect: {
			// 	prev: {
			// 		shadow: false,
			// 		translate: ["-100%", 0, -1],
			// 		opacity: ["0"],
			// 	},
			// 	next: {
			// 		translate: ["100%", 0, 0],
			// 		opacity: ["1"],
			// 	},
			// },
			navigation: {
				nextEl: thisSlider.find('.swiper-button-specifications')[0],
				prevEl: thisSlider.find('.swiper-button-features')[0],
			},
			scrollbar: false,
			pagination: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {

			}
		}).on('slideNextTransitionStart slidePrevTransitionStart', function() {
			// $('.product-detail-slider .swiper-wrapper').removeAttr('style');
			var gotoIndex = slider.realIndex;
			var headerContainer = $('.headerContainer');
			var btn = $('.headerContainer .column-callout .btn');
			var body = $('body');
			headerContainer.addClass('slideTransitionStart');
			if (gotoIndex == 1) {
				headerContainer.removeClass('menu-light').addClass('menu-dark');
				btn.removeClass('btn-dark').addClass('btn-light');
				body.addClass('bg-steel-grey');
				if ($(window).width() < 1024) {
					$('.product-detail-slider > .swiper-wrapper').removeClass('overflow-hidden');
				}
			} else {
				headerContainer.removeClass('menu-dark').addClass('menu-light');
				btn.removeClass('btn-light').addClass('btn-dark');
				body.removeClass('bg-steel-grey');
			}
			window.scrollTo(0,0);
		}).on('slideChangeTransitionEnd', function() {
			var gotoIndex = slider.realIndex;
			var headerContainer = $('.headerContainer');
			headerContainer.removeClass('slideTransitionStart');
			if (gotoIndex == 0 && $(window).width() < 1024) {
				$('.product-detail-slider > .swiper-wrapper').addClass('overflow-hidden');
			}
		});
	});

    var swipers = $('.product-detail-slider');
    swipers.each(function() {
        var swiperEl = this.swiper;
        swiperEl.update();
        $(window).on('resize', function() {
            swiperEl.update();
			setTimeout(function() {
                swiperEl.update();
            }, 50);
        });
    });
}
if ($('.product-thumbs-slider').length) {
	var sliderThumbs = new Swiper('.product-thumbs-slider', {
		direction: "vertical",
		slidesPerView: 3,
		spaceBetween: 15,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		navigation: {
			nextEl: $('.product-thumbs-slider').find('.swiper-button-thumbs-next')[0],
			prevEl: $('.product-thumbs-slider').find('.swiper-button-thumbs-prev')[0],
		},
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
		watchSlidesProgress: true,
		breakpoints: {

		}
	});
}
if ($('.product-image-slider').length) {
	var sliderImages = new Swiper('.product-image-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		// effect: "creative",
		// creativeEffect: {
		// 	prev: {
		// 		shadow: false,
		// 		translate: ["-20%", 0, -1],
		// 	},
		// 	next: {
		// 		translate: ["100%", 0, 0],
		// 	},
		// },
		navigation: {
			nextEl: $('.product-image-slider').find('.swiper-button-image-next')[0],
			prevEl: $('.product-image-slider').find('.swiper-button-image-prev')[0],
		},
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
		thumbs: {
			swiper: sliderThumbs,
		},
		breakpoints: {

		}
	});
}
if ($('.product-features-slider').length) {
	var sliderFeatures = new Swiper('.product-features-slider', {
		slidesPerView: 1,
		spaceBetween: 24,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		navigation: {
			nextEl: $('.product-features-slider').find('.swiper-button-features-next')[0],
			prevEl: $('.product-features-slider').find('.swiper-button-features-prev')[0],
		},
        scrollbar: {
			el: $('.product-features-slider').find('.swiper-scrollbar')[0],
			draggable: true,
			snapOnRelease: true,
        },
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper'
	});
}
if ($('.product-specs-slider').length) {
	var sliderSpecs = new Swiper('.product-specs-slider', {
		slidesPerView: 1,
		spaceBetween: 24,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		navigation: {
			nextEl: $('.product-specs-slider').find('.swiper-button-specs-next')[0],
			prevEl: $('.product-specs-slider').find('.swiper-button-specs-prev')[0],
		},
        scrollbar: {
			el: $('.product-specs-slider').find('.swiper-scrollbar')[0],
			draggable: true,
			snapOnRelease: true,
        },
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
		breakpoints: {

		}
	});
}
if ($('.sections-slider').length) {
	var sliderSections = new Swiper('.sections-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
        scrollbar: {
			el: $('.sections-slider').find('.swiper-scrollbar')[0],
			draggable: true,
			snapOnRelease: true,
        },
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper'
	});
}


if ($('.results-slider').length) {
	restultsSliderInit();
}

$(function () {
	if (document.getElementById('fireResults')) {
		document.getElementById('fireResults').addEventListener('htmx:afterSwap', function(event) {
			restultsSliderInit();
		});
	}
});

function restultsSliderInit() {
	var sliderResults = new Swiper('.results-slider', {
		slidesPerView: 1,
		spaceBetween: 24,
		autoResize: false,
		grabCursor: true,
		speed: 500,
		navigation: {
			nextEl: $('.results-slider').find('.swiper-button-next')[0],
			prevEl: $('.results-slider').find('.swiper-button-prev')[0],
		},
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1696: {
				slidesPerView: 4,
			},
		}
	});
}




function hasScrolled() {
	if ($('.headerContainer.mobile-menu-open').length) {
		return;
	}
	if (($('.section-product-detail').length || $('.section-stores').length) && $(window).width() >= 1024) {
		$('header').removeClass('nav-up').addClass('nav-down');
		return;
	}
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
        
        if(st < 5) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
    
    lastScrollTop = st;
} 



$('.hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	$('.section-calc-mobile .toggle-calc').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-calc-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	$('header .section-calc-mobile').scrollTop(0);
});

$(document).on('click', '.menu-main-mobile li.with-menu-sub', function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
});

$(document).on('click', '.section-calc-mobile .toggle-calc', function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-calc-open');
	$('.hamburger').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	$('header .section-menu-mobile').scrollTop(0);
	// console.log('toggle-calc');
});

$(document).on('click', 'body.mobile-calc-open .backdrop', function(e) {
	e.stopPropagation();
	$('.section-calc-mobile .toggle-calc').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-calc-open');
	// console.log('backdrop');
});

$(document).on('click', 'body.mobile-menu-open .backdrop', function(e) {
	e.stopPropagation();
	$('.hamburger').trigger('click');
});








// CALCULATOR DRAWER

$(document).on('click', 'header .column-callout .btn:not(.open)', function(e) {
	e.preventDefault();
	calcDrawer('open');
});

$(document).on('click', 'header .column-callout .btn.open', function(e) {
	e.preventDefault();
	calcDrawer('close');
});

$(document).on('click', 'body.desktop-calc-open .backdrop', function(e) {
	calcDrawer('close');
});

$(document).on('click', 'body.desktop-calc-open .column-learn a', function(e) {
	calcDrawer('close');
});

function calcDrawer(action) {
	var btn = $('header .column-callout .btn');
	var aside = $('aside.section-calc-desktop');
	var headerContainer = $('.headerContainer');
	if (action == 'open') {
		// var classesHC = headerContainer.attr('class');
		// headerContainer.attr('data-classes', classesHC);
		// var classesB = btn.attr('class');
		// btn.attr('data-classes', classesB);

		$('.section-page-callouts').attr('style', '');

		if ($(window).scrollTop() > 0) {
			$('header').addClass('nav-down');
		}
		var newH = $('.section-calculator-steps[data-type="component"]').outerHeight();
		headerContainer.add('body').addClass('desktop-calc-open');
		headerContainer.removeClass('menu-light').addClass('menu-dark');
		aside.addClass('open');
		aside.css('height', newH);
		btn.addClass('open btn-orange btn-to-white');
		btn.removeClass('btn-dark').addClass('btn-light');
		btn.append('<svg class="close" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18"><g id="Group_20375" data-name="Group 20375" transform="translate(-1912.738 -49)"><rect id="Rectangle_3177" data-name="Rectangle 3177" width="10" height="18" transform="translate(1912.738 49)" fill="none"/><path id="Path_15058" data-name="Path 15058" d="M667.664,915.424l-1.414-1.414-3.584,3.584-3.583-3.583-1.414,1.414,3.584,3.584-3.584,3.584,1.414,1.414,3.584-3.584,3.583,3.583,1.414-1.414-3.584-3.584Z" transform="translate(1255.072 -861.008)" fill="currentColor"/></g></svg>');
	} else {

		$('.section-page-callouts').attr('z-index', '80');

		headerContainer.add('body').removeClass('desktop-calc-open');
		headerContainer.removeAttr('class');
		headerContainer.addClass(headerContainer.data('classes'));
		btn.removeAttr('class');
		btn.addClass(btn.data('classes'));
		// if (headerContainer.hasClass('menu-transparent')) {
		// 	headerContainer.removeClass('menu-dark').addClass('menu-transparent');	
		// 	btn.removeClass('btn-dark').removeClass('btn-light');
		// } else if (headerContainer.hasClass('menu-dark')) {
		// 	headerContainer.removeClass('menu-light').addClass('menu-dark');
		// 	btn.removeClass('btn-dark').addClass('btn-light');
		// } else {
		// 	headerContainer.removeClass('menu-dark').addClass('menu-light');
		// 	btn.removeClass('btn-light').addClass('btn-dark');
		// }
		// console.log('her 2');


		aside.removeClass('open');
		aside.removeAttr('style');
		btn.removeClass('open btn-orange btn-to-white');
		btn.parent().removeAttr('style');
		btn.find('.close').remove();

		if ($('body.fires.bg-steel-grey').length) {
			btn.removeClass('btn-dark').addClass('btn-light');
			headerContainer.removeClass('menu-light').addClass('menu-dark');
		}
	}
}

function calcDrawerInit() {
	var section = $('.section-calculator-steps[data-type="component"]');
	if ($(window).width() >= 1280) {
		if ($('aside.section-calc-desktop .section-calculator-steps').length == 0) {
			section.appendTo("aside.section-calc-desktop");
		}
	} else {
		if ($('header .section-calc-mobile .section-calculator-steps').length == 0) {
			section.appendTo("header .section-calc-mobile");
		}
	}
}

// CALCULATOR DRAWER



// HOME

function homeHeroHeadInit(scroll) {

	var heading = $('.floating-heading');
	if (heading.length) {
		
		var posFirstSlide = $(window).height() - heading.outerHeight();
		heading.removeAttr('style');
		var posCurrent = heading.offset().top;
		var posDiff = posFirstSlide - posCurrent;
		heading.attr('data-initial-offset', posDiff);
		if ($('.home-hero-section').visible(true)) {
			heading.css('transform','translate3d(0px, ' + posDiff + 'px, 0px)');
			setTimeout(() => {
				heading.find('h1').addClass('slideUp');
			}, 1000);
		}	
	}

	var section = $('.home-hero-slides');
	var sectionOffset = section.offset().top;
	var inner = section.find('.home-hero-slides-inner');
	if (scroll >= sectionOffset || inner.visible(true)) {
		homeHeroHead(scroll);
		homeHeroSlides(scroll, section);
	}


}

function homeHeroHead(scroll) {

	// var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	// // console.log('safari ' + is_safari);
	// console.log('scroll ' + scroll);
    
	// if(Math.abs(lastScrollTop - scroll) > 50 && is_safari) {
	// 	return false;
	// }

	// console.log('SCROLL SPEED ' + (lastScrollTop - scroll));
	var heading = $('.floating-heading');
	var initialOffset = heading.data('initial-offset');
	var newOffset = initialOffset + scroll / 1.5;
	if (newOffset >= 0) {
		newOffset = 0;
		// $('body').removeClass('remove-jumpiness');
	} else {
		// $('body').addClass('remove-jumpiness');
		// console.log('this one');
	}
	// console.log('newOffset ' + newOffset);
	heading.css('transform','translate3d(0px, ' + newOffset + 'px, 0px)');

    // lastScrollTop = scroll;
}

function homeHeroSlides(scroll, section) {
	var initialOffset = $('.floating-heading').data('initial-offset');
	if (isNaN(initialOffset)) {
		// console.log('NAN');
		return false;
	}
	var sectionOffset = section.offset().top;
	var innerBlockEl = section.find('.home-hero-slides-inner');
	var innerEl = innerBlockEl.find('.floating-section');
	var indicatorEl = section.find('.indicator');
	var indicatorElOffset = indicatorEl.offset().top;
	var imageElOne = section.find('.floating-image-one');
	var imageElTwo = section.find('.floating-image-two');
	var headElOne = section.find('.floating-heading-one');
	var headElTwo = section.find('.floating-heading-two');
	var descrElOne = section.find('.description-one');
	var descrElTwo = section.find('.description-two');


	if (!section.visible(true) && !innerBlockEl.visible(true)) {
		return false;
	}


	if (scroll >= (sectionOffset + innerEl.height())) {
		innerEl.css({ position: 'absolute', top: 0 });
		innerBlockEl.css({ position: 'absolute', bottom: 0 });
		imageElTwo.css('opacity', 0);
		headElTwo.css('opacity', 0);
		headElTwo.css('pointer-events', 'none');
		// headElTwo.find('.h1').removeClass('slideUp').addClass('slideDown');
		descrElTwo.css('opacity', 0).css('transform', 'translateY(100px)');
	} else if (scroll >= sectionOffset) {
		innerEl.css({ position: 'fixed', bottom: 0 });
		innerBlockEl.css({position: 'relative'});
	} else {
		innerEl.css({ position: 'relative', top: 0 });
		innerBlockEl.css({position: 'relative'});
		imageElOne.css('opacity', 1);
		imageElTwo.css('opacity', 0);
		headElOne.css('opacity', 1);
		headElOne.find('h1').removeClass('slideDown').addClass('slideUp');
		headElTwo.css('opacity', 0);
		headElTwo.css('pointer-events', 'none');
		headElTwo.find('.h1').removeClass('slideUp').addClass('slideDown');
		descrElOne.css('opacity', 1).css('transform', 'translateY(0px)');
		descrElTwo.css('opacity', 0).css('transform', 'translateY(100px)');
	}


	if ((scroll - indicatorElOffset + ($(window).height() / 1.3)) > 0 && indicatorEl.visible(true)) {
		imageElOne.css('opacity', 0);
		imageElTwo.css('opacity', 1);
		headElOne.css('opacity', 0);
		headElOne.find('h1').removeClass('slideUp').addClass('slideDown');
		headElTwo.css('opacity', 1);
		headElTwo.css('pointer-events', 'auto');
		headElTwo.find('.h1').removeClass('slideDown').addClass('slideUp');
		descrElOne.css('opacity', 0).css('transform', 'translateY(-100px)');
		descrElTwo.css('opacity', 1).css('transform', 'translateY(0px)');
	} else if ((scroll - indicatorElOffset + ($(window).height() / 1.3)) > 0 && !indicatorEl.visible(true)) {
		imageElOne.css('opacity', 0);
		imageElTwo.css('opacity', 1);
		headElOne.css('opacity', 0);
		headElOne.find('h1').removeClass('slideUp').addClass('slideDown');
		headElTwo.css('opacity', 1);
		headElTwo.css('pointer-events', 'auto');
		headElTwo.find('.h1.slideDown:not(.slideUp)').removeClass('slideDown').addClass('slideUp');
		descrElOne.css('opacity', 0).css('transform', 'translateY(-100px)');
		descrElTwo.css('opacity', 1).css('transform', 'translateY(0px)');
	} else {
		imageElOne.css('opacity', 1);
		imageElTwo.css('opacity', 0);
		headElOne.css('opacity', 1);
		headElOne.find('h1').removeClass('slideDown').addClass('slideUp');
		headElTwo.css('opacity', 0);
		headElTwo.css('pointer-events', 'none');
		headElTwo.find('.h1').removeClass('slideUp').addClass('slideDown');
		descrElOne.css('opacity', 1).css('transform', 'translateY(0px)');
		descrElTwo.css('opacity', 0).css('transform', 'translateY(100px)');
	}
}

// HOME






// FIRES FILTERS AND COMPARE

$('.section-fires-filters:not(.filters-open)').on("click", function(e) {
	var h = $(this).find('.container').outerHeight();
	$(this).css('height', h);
	$(this).addClass('filters-open');
	e.stopPropagation();
});
$('.section-fires-filters .close-filters').on("click", function(e) {
	$('.section-fires-filters').removeAttr('style');
	$('.section-fires-filters').removeClass('filters-open');
	e.stopPropagation();
});

$('.filter-trigger').on("click", function(e) {
    var filterName = $(this).data('filter');
	if ($(this).hasClass('active')) {
		$(this).removeClass('active');
		var filterValue = '';
	} else {
		var filterValue = $(this).data('filter-value');
	}

    const url = new URL(window.location);
    url.searchParams.set(filterName, filterValue);
    window.history.pushState({}, '', url);

    fuelFilter();
});

$('.clear-filters').on("click", function(e) {
    const url = new URL(window.location);
    url.searchParams.set('style', '');
    url.searchParams.set('fuel', '');
    url.searchParams.set('air', '');
    window.history.pushState({}, '', url);
	$('.section-fires-listing').show();
    fuelFilter();
});


$(function () {

	fuelFilter();

    $(window).on('popstate', function(e) {
		fuelFilter();
    });

	var btns = $('.sprig-compare');
	btns.each(function(i) {
		var id = '#' + $(this).attr('id');
		htmx.trigger(id, 'refresh');
	});

});


function fuelFilter() {
	var fires = $('.section-fires-listing .column-fire');

	var dataStyle = '';
	var style = getUrlParameter('style');
    if (style) {
        dataStyle = dataStyle + "[data-style*='" + style + "']";
		$('.filter-trigger[data-filter="style"]').removeClass('active');
		$('.filter-trigger[data-filter="style"][data-filter-value*="' + style + '"]').addClass('active');
    }
    var fuel = getUrlParameter('fuel');
    if (fuel) {
        dataStyle = dataStyle + "[data-fuel*='" + fuel + "']";
		$('.filter-trigger[data-filter="fuel"]').removeClass('active');
		$('.filter-trigger[data-filter="fuel"][data-filter-value*="' + fuel + '"]').addClass('active');
    }
    var air = getUrlParameter('air');
    if (air) {
        dataStyle = dataStyle + "[data-air*='" + air + "']";
		$('.filter-trigger[data-filter="air"]').removeClass('active');
		$('.filter-trigger[data-filter="air"][data-filter-value*="' + air + '"]').addClass('active');
    }

	if (style || fuel || air) {
		$('.section-fires-filters .clear-filters').addClass('show');
		$('.section-fires-filters:not(.filters-open)').trigger('click');
	} else if (style == '' && fuel == '' && air == '') {
		$('.section-fires-filters .clear-filters').removeClass('show');
		fires.show();
		$('.section-fires-listing').show();
		$('.filter-trigger').removeClass('active');
		$('.section-fires-filters .column-filter .results').html(fires.length + ' results');
		return false;
	} 

	fires.hide();
	var selected = $('.section-fires-listing .column-fire' + dataStyle);

	selected.show();
	var result = selected.length;
	if (selected.length == 1) {
		result = result + ' result';
	} else {
		result = result + ' results';
	}
	$('.section-fires-filters .column-filter .results').html(result);
	$('.section-fires-filters .collapsed-filter .results').html(result);

	var sections = $('.section-fires-listing');
	sections.show();
	sections.each(function() {
		var fires = $(this).find('.column-fire:visible');
		if (fires.length == 0) {
			$(this).hide();
		}
	});
}

$(document).on('click', '.compareBtn', function(e) {
    $(this).find('.loader').removeClass('opacity-0');
	var fire = $(this).data('btn-fire');
	$('.removeCompareBtn[data-fire="' + fire + '"] .loader').removeClass('opacity-0');
});

$(document).on('click', '.removeCompareBtn', function(e) {
    var fire = $(this).data('fire');
	$('.compareBtn[data-btn-fire="' + fire + '"]').trigger('click');
    $(this).find('.loader').removeClass('opacity-0');
});

$(document).on('click', '.clear-compare', function(e) {
    $(this).find('.loader').removeClass('opacity-0');
});

// FIRES FILTERS AND COMPARE







// SEARCH

$(document).on('click', '.search-filter:not(.active)', function(e) {
	e.stopPropagation();
    var type = $(this).data('type');
	$('.search-filter').removeClass('active');
	$(this).addClass('active');
	$('.section-results').hide();
	$('.section-results[data-section-type="' + type + '"]').show();
});
$(document).on('click', '.search-filter.active', function(e) {
    e.stopPropagation();
	$('.search-filter').removeClass('active');
	$('.section-results').show();
});

$(document).on('click', '.li-search:not(.active)', function(e) {
    e.stopPropagation();
    e.preventDefault();
	$(this).addClass('active');
	$(this).find('input').trigger('focus');
});
// SEARCH






// NEWS

$(document).on('change', 'select[name="news-filter"]', function(e) {
    e.stopPropagation();
	var category = $(this).val();
	if (category != 'all') {
		$('.article-card').hide();
		$('.article-card[data-category="' + category + '"]').show();
	} else {
		$('.article-card').show();
	}
});

// NEWS











// CALCULATOR

$(document).on('submit', '.section-calculator-steps[data-type="page"] #calculatorForm', function(e) {
	e.preventDefault();
	$('.section-calculator-steps[data-type="page"] #calculatorForm button').html('Calculating . . .');
	var section = $('.section-fires-results');
	section.removeAttr('style');
	var formData = $(this).serializeArray();
	var zone = formData[0].value;
	var homeAge = formData[1].value;
	var heatingSpace = parseInt(formData[2].value);

	$.getJSON( "/dist/" + zone + ".json", function( data ) {
		var items = data;
		items = data.filter(function(obj) {
			return obj.Footprint === heatingSpace;
		});
		if (items.length) {
			var result = items[0][homeAge];
			$('#calculatorResult').html(result);
			var fires = $('.section-fires-results .swiper-slide[data-fire]');
			fires.hide();
			var lowest = 100;
			var highest = 0;
			fires.each(function() {
				var high = parseFloat($(this).attr('data-heat-high'));
				var low = parseFloat($(this).attr('data-heat-low'));
				if (result >= low && result <= high) {
					$(this).show();
				}
				if (low < lowest) {
					lowest = low;
				}
				if (high > highest) {
					highest = high;
				}
			});
			var visibleFires = $('.section-fires-results .swiper-slide[data-fire]:visible');
			if (visibleFires.length == 0) {
				if (result < lowest) {
					$('.section-fires-results .swiper-slide[data-fire][data-heat-low="' + lowest + '"]').show();
				}
				if (result > highest) {
					$('.section-fires-results .swiper-slide[data-fire][data-heat-high="' + highest + '"]').show();
				}
			}

			const swiperProductsSliderEl = document.querySelector('.results-slider').swiper;
			if (swiperProductsSliderEl) {
				swiperProductsSliderEl.update();
				swiperProductsSliderEl.slideTo(0);
			}

			section.attr('data-columns', $('.section-fires-results .swiper-slide[data-fire]:visible').length);

			var newH = $('.section-fires-results .container').outerHeight();
			section.css('height', newH);

			$([document.documentElement, document.body]).animate({
                scrollTop: section.offset().top
            }, 100);

		}
	})
	.fail(function() { 
		$('#calculatorForm button').html('Calculate');
	})
	.done(function() { 
		$('#calculatorForm button').html('Calculate');
	});
	
});

$(function () {
	if (document.getElementById('fireResults')) {
		document.getElementById('fireResults').addEventListener('htmx:afterSwap', function(event) {
			if ($('.section-calculator-steps[data-type="page"]').length) {
				var zone = getUrlParameter('zone');
				if (zone) {
					$('select[name="zone"]').val(zone);
				}
				var homeAge = getUrlParameter('homeAge');
				if (homeAge) {
					$('select[name="homeAge"]').val(homeAge);
				}
				var heatingSpace = getUrlParameter('heatingSpace');
				if (heatingSpace) {
					$('select[name="heatingSpace"]').val(heatingSpace);
				}
				if (zone && homeAge && heatingSpace) {
					$('.section-calculator-steps[data-type="page"] #calculatorForm button').trigger('click');
				}
			}
		});
	}
});
// CALCULATOR







// SHOP FILTERS



$(function () {

    // var sort = getUrlParameter('sort');
    // if (sort) {
    //     sortProducts(sort);
	// 	$('#products-filters select').val(sort);
    // } else {
	// 	sortProducts('');
	// 	$('#products-filters select').val();
	// }

});

$(document).on('click', '.category-filter[sprig], button[sprig], .clear-filters[sprig], .load-more-row[sprig]', function(e) {
	$('.products-loader').removeClass('hidden');
});


$(document).on('click', '#products-filters .subheading', function(e) {
	var head = $(this);
	var options = head.next('.columns');
	if (head.hasClass('open-init')) {
		options.slideUp({
			complete: function () {
				head.removeClass('open-init');
			}
		});
	} else {
		if (head.hasClass('open')) {
			options.slideUp({
				complete: function () {
					head.removeClass('open');
				}
			});
		} else {
			options.slideDown({
				start: function () {
					$(this).css({display: "flex"});
					$(this).css('max-height', $(this).css('height'));
				},
				complete: function () {
					head.addClass('open');
				}
			});
		}
	}	
});


$(document).on('click', '#products-filters button[sprig], #products-filters .category-filter[sprig]', function(e) {
	$([document.documentElement, document.body]).animate({
		scrollTop: $('#products-filters').offset().top
	}, 100);
});


// $(document).on('change', '#products-filters select', function(e) {
// 	e.stopPropagation();
//     var sort = $(this).val();
// 	sortProducts(sort);
// });

// function sortProducts(sort) {
//     const url = new URL(window.location);

// 	var loadMore = $("#products-filters .load-more-row"); 
// 	var divList = $("#products-filters .product-card");
// 	if (sort == "priceLowHigh"){
// 		divList.sort(function(a, b){
// 			return $(a).data("price")-$(b).data("price")
// 		});
// 	} else if (sort == "priceHighLow") {
// 		divList.sort(function(a, b){
// 			return $(b).data("price")-$(a).data("price")
// 		});
// 	} else {
// 		divList.sort(function(a, b){
// 			return $(a).find(".heading").text().toUpperCase().localeCompare($(b).find(".heading").text().toUpperCase());
// 		});
// 	}

// 	$("#products-filters .product-grid").html(divList);  
// 	$("#products-filters .product-grid").append(loadMore);  

//     url.searchParams.set('sort', sort);
//     window.history.pushState({}, '', url);

// 	var sprigs = $('#products-filters [s-push-url]');
// 	sprigs.each(function() {
// 		var thisUrl = $(this).attr('s-push-url').split('&sort');
// 		var newUrl = thisUrl[0] + '&sort=' + sort;
// 		$(this).attr('s-push-url', newUrl);
// 		$(this).attr('data-hx-push-url', newUrl);
// 	});

// }

// if ($('#products-filters').length) {

// 	htmx.on('htmx:afterSwap', function(event) {
// 		var sort = getUrlParameter('sort');
// 		if (sort) {
// 			sortProducts(sort);
// 			$('#products-filters select').val(sort);
// 		} else {
// 			sortProducts('');
// 			$('#products-filters select').val();
// 		}
// 	});

// }